// tslint:disable:no-any
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import { loadDiveData } from '../actions/diveActions';
import { GeneralResponse } from '../api';
import DiveConfirmModal from '../components/DiveConfirmModal';
import EditDiveForm from '../components/EditDiveForm';
import Loader from '../components/Loader';
import Message from '../components/Message';
import { isUniqueMessage } from '../components/Messages';
import Title from '../components/Title';
import Validation from '../components/Validation';
import { DiveService } from '../services/DiveService';
import Dt from 'react-document-title';
import { NavigationStore } from './Navigation/NavigationStore';
import { convertDiveDataToSave } from './DiveData';
import DiveDataHeader from './DiveDataHeader';

// import Navigation from '../components/Navigation';
export interface IEditDiveProps {
    loadDiveData: any;
    match: any;
    dive: any;
}

interface IEditDiveState {
    validFields: any;
    requiredFields: any;
    dive: any;
    showConfirmSubmit: boolean;
    messages: any;
    redirectToDetail: boolean;
    disableSubmit: boolean;
    confirmSubmit: boolean;
}

class EditDive extends Component<IEditDiveProps, IEditDiveState> {
    constructor(props: IEditDiveProps) {
        super(props);
        this.state = {
            dive: null,
            validFields: {},
            requiredFields: {},
            // zobrazeni hlasky potvrzeni
            showConfirmSubmit: false,
            // hlasky
            messages: [],
            // redirect zpet na detail ponoru
            redirectToDetail: false,
            disableSubmit: false,
            confirmSubmit: false
        };
    }

    componentWillReceiveProps(nextProps: IEditDiveProps) {
        this.setState(
            {
                dive: nextProps.dive
            },
            () => {
                this.checkValidAndRequired();
            }
        );
    }

    componentDidMount() {
        // Navigation._setActive('dives', 'Dive edit');
        window.scrollTo(0, 0);
        this.props.loadDiveData(this.props.match.params.diveId);

        NavigationStore.getInstance().setActive('dives');
    }

    setValidField(name: string, valid: boolean) {
        var newValidFields = this.state.validFields;

        newValidFields[name] = valid;

        if (valid === false) {
            this.setState({
                disableSubmit: true
            });
        }

        this.setState({
            validFields: newValidFields
        });
    }

    setValidFieldMessage(name: string, message: any) {
        var newValidFields = this.state.validFields;

        newValidFields[name] = message;

        if (message !== null) {
            this.setState({
                disableSubmit: true
            });
        }

        this.setState({
            validFields: newValidFields
        });
    }

    setRequiredField(name: string, required: boolean) {
        var newRequiredFields = this.state.requiredFields;

        newRequiredFields[name] = required;

        if (required === true) {
            this.setState({
                confirmSubmit: true
            });
        }

        this.setState({
            requiredFields: newRequiredFields
        });
    }

    checkValidAndRequired() {
        var data = this.state.dive.diveAndMixes.dive;

        this.setState(
            {
                disableSubmit: false,
                confirmSubmit: false
            },
            () => {
                this.setValidField(
                    'visibility',
                    data.visibility === '' ||
                        data.visibility === null ||
                        Validation.isRealNumber(data.visibility)
                );
                this.setValidField(
                    'surfaceTemp',
                    data.surfaceTemp === '' ||
                        data.surfaceTemp === null ||
                        Validation.isRealNumber(data.surfaceTemp)
                );
                this.setValidField(
                    'weight',
                    data.weight === '' ||
                        data.weight === null ||
                        Validation.isRealNumber(data.weight)
                );

                this.setValidField(
                    'latitude',
                    data.latitude === '' ||
                        data.latitude === null ||
                        Validation.isRealNumber(data.latitude)
                );
                this.setValidField(
                    'longitude',
                    data.longitude === '' ||
                        data.longitude === null ||
                        Validation.isRealNumber(data.longitude)
                );

                this.setRequiredField(
                    'latitude',
                    data.latitude === '' || data.latitude === null
                );
                this.setRequiredField(
                    'longitude',
                    data.longitude === '' || data.longitude === null
                );

                // kontrola validace hodnot ze vsech mixu
                this.state.dive.diveAndMixes.mixes.forEach(
                    (mixesData: any, index: number) => {
                        this.setValidField(
                            'tankVolume' + index,
                            mixesData.tankVolume === '' ||
                                mixesData.tankVolume === null ||
                                Validation.isRealNumber(mixesData.tankVolume)
                        );
                        this.setValidField(
                            'startPressure' + index,
                            mixesData.startPressure === '' ||
                                mixesData.startPressure === null ||
                                Validation.isRealNumber(mixesData.startPressure)
                        );
                        this.setValidField(
                            'endPressure' + index,
                            mixesData.endPressure === '' ||
                                mixesData.endPressure === null ||
                                Validation.isRealNumber(mixesData.endPressure)
                        );

                        // kontrola hodnot
                        this.setValidFieldMessage(
                            'endPressure' + index + 'message',
                            null
                        );
                        if (
                            this.state.validFields['endPressure' + index] ===
                                true &&
                            this.state.validFields['endPressure' + index] ===
                                true
                        ) {
                            if (
                                parseFloat(mixesData.endPressure) >
                                parseFloat(mixesData.startPressure)
                            ) {
                                this.setValidFieldMessage(
                                    'endPressure' + index + 'message',
                                    'The start pressure has to be higher than the end pressure'
                                );
                            }
                        }
                    }
                );
            }
        );
    }

    onChangeDiveData(event: any) {
        let paramName = event.target.name;
        let paramValue = event.target.value;
        let newDive = this.state.dive;

        newDive.diveAndMixes.dive[paramName] = paramValue;

        // souradnice
        if (paramName === 'latitude' || paramName === 'longitude') {
            if (paramValue !== '' && Validation.isRealNumber(paramValue)) {
                newDive.diveAndMixes.dive[paramName] = paramValue;
            }
        }

        this.setState(
            {
                dive: newDive
            },
            () => {
                this.checkValidAndRequired();
            }
        );
    }

    onChangeGpsData(event: any) {
        let newDive = this.state.dive;

        newDive.diveAndMixes.dive.latitude = event.lat;
        newDive.diveAndMixes.dive.longitude = event.lng;

        this.setState(
            {
                dive: newDive
            },
            () => {
                this.checkValidAndRequired();
            }
        );
    }

    onChangeDiveType(newDiveType: any) {
        let newDive = this.state.dive;

        newDive.diveAndMixes.dive.diveType = newDiveType;

        this.setState(
            {
                dive: newDive
            },
            () => {
                this.checkValidAndRequired();
            }
        );
    }

    onChangeMixesData(newMixesData: any) {
        let newDive = this.state.dive;

        newDive.diveAndMixes.dive.mixes = newMixesData;

        this.setState(
            {
                dive: newDive
            },
            () => {
                this.checkValidAndRequired();
            }
        );
    }

    showConfirmSubmit(event: Event) {
        this.setState({
            showConfirmSubmit: true
        });
        event.preventDefault();
    }

    hideConfirmSubmit() {
        this.setState({
            showConfirmSubmit: false
        });
    }

    addMessages(text: string, type: string) {
        if (isUniqueMessage(text, this.state.messages)) {
            let newMessages = [...this.state.messages];
            newMessages.push({
                text: text,
                type: type
            });

            this.setState({
                messages: newMessages
            });
        }
    }

    clearMessages() {
        this.setState({
            messages: []
        });
    }

    async submitDivesData(event: any) {
        // convert dive data to save
        let dive = convertDiveDataToSave({...this.state.dive.diveAndMixes});

        // data for update
        let saveDiveData = {
            dive: dive.dive,
            mixes: dive.mixes
        };

        const result = await DiveService.getInstance().submitDives(
            this.state.dive.diveAndMixes.dive.id,
            saveDiveData,
            true
        );
        if (result == undefined) {
            return;
        }

        if ((result as GeneralResponse) != undefined) {
            this.setState({
                redirectToDetail: true
            });
        } else {
            this.addMessages('Dive could not be saved!', 'error');
        }

        // skryti hlasky, pokud je zobrazena
        this.hideConfirmSubmit();

        event.preventDefault();
    }

    render() {
        const { dive } = this.state;

        if (dive === undefined || dive === null) {
            return <Loader />;
        }

        return (
            <Dt title={'WetNotes | Dive edit'}>
                <div className="dive edit-dive">
                    <Title
                        heading={`Edit Dive #${dive.diveAndMixes.dive.serial}`}
                        breadcrumbs={[
                            { caption: 'My Dives', to: '/app/dives' },
                            {
                                caption: `Edit Dive #${
                                    dive.diveAndMixes.dive.serial
                                }`,
                                to: `/app/dive/edit/${
                                    dive.diveAndMixes.dive.id
                                }`
                            }
                        ]}
                    />

                    <div className="wrapper">
                        <div className="messages">
                            {this.state.messages.map(
                                (message: any, i: number) => {
                                    return (
                                        <Message
                                            key={i}
                                            type={message.type}
                                            text={message.text}
                                            autoClose={true}
                                            onClose={() => this.clearMessages()}
                                        />
                                    );
                                }
                            )}
                        </div>

                        <div>
                            <div className="standardContainer">
                                <DiveDataHeader
                                    startDate={dive.diveAndMixes.dive.startDate}
                                    duration={dive.diveAndMixes.dive.duration}
                                    maxDepth={dive.diveAndMixes.dive.maxDepth}
                                    averageDepth={dive.diveAndMixes.dive.averageDepth}
                                />

                                <EditDiveForm
                                    dive={dive}
                                    validFields={this.state.validFields}
                                    requiredFields={this.state.requiredFields}
                                    onChangeDiveData={(e: any) =>
                                        this.onChangeDiveData(e)
                                    }
                                    onChangeGpsData={(e: any) =>
                                        this.onChangeGpsData(e)
                                    }
                                    onChangeDiveType={(newDiveType: any) =>
                                        this.onChangeDiveType(newDiveType)
                                    }
                                    onChangeMixesData={(newMixesData: any) =>
                                        this.onChangeMixesData(newMixesData)
                                    }
                                    confirmSubmit={this.state.confirmSubmit}
                                    disableSubmit={this.state.disableSubmit}
                                    showConfirmSubmit={(e: any) =>
                                        this.showConfirmSubmit(e)
                                    }
                                    submitDivesData={(e: any) =>
                                        this.submitDivesData(e)
                                    }
                                />
                            </div>
                        </div>
                    </div>

                    <DiveConfirmModal
                        title="Are you sure you want to save this dive?"
                        description="Some dives do not have complete data (GPS coordinates)"
                        display={this.state.showConfirmSubmit}
                        hideConfirmSubmit={() => this.hideConfirmSubmit()}
                        submitDivesData={e => this.submitDivesData(e)}
                    />

                    {this.state.redirectToDetail && (
                        <Redirect
                            to={`/app/dives/${
                                this.state.dive.diveAndMixes.dive.id
                            }`}
                        />
                    )}
                </div>
            </Dt>
        );
    }
}

const mapStateToProps = (state: any) => ({
    dive: state.dive || {}
});

const mapDispatchToProps = (dispatch: any) => ({
    loadDiveData: (diveId: any) => dispatch(loadDiveData(diveId))
});

export default connect(mapStateToProps, mapDispatchToProps)(EditDive);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/EditDive.tsx